import React from "react";
import { Link } from "react-router-dom";
import "../../styles/ReportListPage.css";
import useAccess from "../../hooks/useAccess";

const reportCategories = [
  {
    title: "Employment Reports",
    description: "Workforce records, compliance dates, and workplace incidents.",
    icon: "fa-solid fa-briefcase",
    reports: [
      { name: "Time And Attendance", icon: "fa-regular fa-clock" },
      { name: "Expirations", icon: "fa-regular fa-calendar-check" },
      {
        name: "Incident Accident Registry",
        icon: "fa-solid fa-triangle-exclamation",
      },
    ],
  },
  {
    title: "Recruitment Reports",
    description: "Hiring activity, candidate progress, and associate insights.",
    icon: "fa-solid fa-users",
    reports: [
      { name: "Associate Turnover", icon: "fa-solid fa-arrow-rotate-left" },
      { name: "Hiring Cycle", icon: "fa-solid fa-repeat" },
      { name: "Hiring Cycle Data", icon: "fa-solid fa-chart-line" },
      { name: "Position History", icon: "fa-solid fa-clock-rotate-left" },
      { name: "Termination", icon: "fa-solid fa-user-minus" },
      { name: "Document Status", icon: "fa-regular fa-file-lines" },
      { name: "Contact List", icon: "fa-regular fa-address-book" },
      { name: "LEEP Report", icon: "fa-solid fa-clipboard-check" },
    ],
  },
];

const getReportPath = (name) =>
  `/reports/${name.replace(/\s+/g, "-").toLowerCase()}`;

function ReportListPage() {
  const { hasPermission } = useAccess();
  const visibleCategories = reportCategories
    .map((category) => ({
      ...category,
      reports: category.reports.filter((report) => {
        const resource =
          report.name === "Incident Accident Registry"
            ? "Incident / Accident Registry"
            : report.name === "LEEP Report"
              ? "L.E.E.P. Report"
              : report.name;
        return hasPermission("Reports", resource, "view");
      }),
    }))
    .filter((category) => category.reports.length);

  return (
    <main className="report-library">
      <header className="report-library__header">
        <div>
          <p className="report-library__eyebrow">Reporting centre</p>
          <h1>Reports</h1>
          <p className="report-library__intro">
            Find the workforce and recruitment information you need.
          </p>
        </div>
      </header>

      <div className="report-library__grid">
        {visibleCategories.map((category) => (
          <section className="report-category" key={category.title}>
            <div className="report-category__header">
              <span className="report-category__icon" aria-hidden="true">
                <i className={category.icon} />
              </span>
              <div>
                <h2>{category.title}</h2>
                <p>{category.description}</p>
              </div>
              <span className="report-category__count">
                {category.reports.length}
              </span>
            </div>

            <div className="report-category__links">
              {category.reports.map((report) => (
                <Link
                  className="report-link"
                  key={report.name}
                  to={getReportPath(report.name)}
                >
                  <span className="report-link__icon" aria-hidden="true">
                    <i className={report.icon} />
                  </span>
                  <span className="report-link__label">{report.name}</span>
                  <i
                    className="fa-solid fa-arrow-right report-link__arrow"
                    aria-hidden="true"
                  />
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>
    </main>
  );
}

export default ReportListPage;
